import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import React from "react";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import MDSnackbar from "../../../components/MDSnackbar";
import useNewSale from "./useNewSale";
import TextField from "@mui/material/TextField";
import {InputAdornment, Modal} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowIcon from "@mui/icons-material/ArrowBack";
import MDAutocomplete from "../../../components/MDAutocomplete";

const NewSale = () => {
    const { navigate, saleProducts, patients,  patientId, isSubmitting, isLoading, show, snackbarConfig, calculateTotal, calculateSubtotal, calculateDiscount, handlePatientIdChange, handleSearch, handleSubmit, toggleSnackbar, renderProducts, renderLineItems } = useNewSale();

    return (
        <MDBox>
            <Grid container>
                <MDBox id="cart" component={Grid} item xs={12} lg={3} height="100vh" style={{backgroundColor: 'white', position: 'sticky', top: 0, overflow: 'hidden'}}>
                    {
                        isLoading ?
                                <MDBox mt={2} mx={2} p={10} display="flex" justifyContent="center"
                                       alignItems="center">
                                    <CircularProgress color="secondary" style={{overflow: 'hidden'}}/>
                                </MDBox> :
                            <>
                                <MDBox sx={{padding: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', borderBottomStyle: 'solid', borderBottomWidth: 1, borderBottomColor: '#cecece'}}>
                                    <IconButton onClick={() => navigate("/ventas")} sx={{backgroundColor: '#FFFFFF'}} color="secondary" size="medium">
                                        <ArrowIcon />
                                    </IconButton>
                                    <MDTypography variant="headline5">Nueva Venta</MDTypography>
                                </MDBox>
                                <MDBox sx={{height: 'calc(100vh - 250px)', overflowY: 'scroll', position: 'relative'}}>
                                    {
                                        saleProducts.length > 0 ?
                                            renderLineItems() :
                                            <MDBox sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                                                <MDTypography variant="body1">No se han agregado productos</MDTypography>
                                            </MDBox>
                                    }

                                </MDBox>
                                <MDBox
                                    sx={{
                                        position: 'absolute',
                                        bottom: 0,
                                        left: 0,
                                        right: 0,
                                        p: 2,
                                        backgroundColor: '#FFFFFF',
                                        borderTop: '1px solid #f7f7f7',
                                        boxShadow: '0 -5px 5px -5px rgba(0, 0, 0, 0.2)'
                                    }}
                                >
                                    <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                        <MDTypography variant="body2" component="div" align="left">
                                            <b>Subtotal</b>
                                        </MDTypography>
                                        <MDTypography variant="body2" component="div" align="right">
                                            ${calculateSubtotal().toFixed(2)}
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                        <MDTypography variant="body2" component="div" align="left">
                                            <b>Descuento</b>
                                        </MDTypography>
                                        <MDTypography variant="body2" component="div" align="right">
                                            ${calculateDiscount().toFixed(2)}
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                        <MDTypography variant="subtitle1" component="div" align="left">
                                            <b>Total</b>
                                        </MDTypography>
                                        <MDTypography variant="subtitle1" component="div" align="right">
                                            ${calculateTotal().toFixed(2)}
                                        </MDTypography>
                                    </MDBox>
                                    <MDAutocomplete
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        id="patientId"
                                        label="Paciente"
                                        name="patientId"
                                        value={patientId}
                                        options={patients}
                                        onChange={handlePatientIdChange}
                                    />
                                    <MDButton sx={{marginTop: 1}} onClick={handleSubmit} disabled={saleProducts.length === 0 || patientId < 1} fullWidth variant="contained" color="secondary">
                                        {isSubmitting && <CircularProgress size={18} color="white" sx={{marginRight: 1}}/>}
                                        REGISTRAR
                                    </MDButton>
                                </MDBox>
                            </>
                    }

                </MDBox>
                <MDBox component={Grid} item xs={12} lg={9} p={3} style={{overflowY: 'auto'}}>
                    <Card sx={{paddingLeft: 2, paddingRight: 2, paddingBottom: 1, marginBottom: 2}}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="search"
                            label="Buscar Producto"
                            name="search"
                            autoFocus
                            onChange={handleSearch}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Card>
                    <Grid container spacing={2}>
                        {
                            isLoading ?
                                <Grid item lg={12} xs={12}>
                                    <MDBox mt={2} mx={2} p={10} display="flex" justifyContent="center"
                                           alignItems="center">
                                        <CircularProgress color="secondary" style={{overflow: 'hidden'}}/>
                                    </MDBox>
                                </Grid>
                                    :
                                renderProducts()
                        }
                    </Grid>
                </MDBox>
            </Grid>
            <MDSnackbar
                color={snackbarConfig.color}
                icon={snackbarConfig.icon}
                title={snackbarConfig.title}
                content={snackbarConfig.message}
                dateTime=""
                autoHideDuration={3000}
                open={show}
                close={toggleSnackbar}
            />
        </MDBox>
    );
};

export default NewSale;
